import {RouteNames, BuilderTabIds} from "./constants";
import {guid} from "@core/Util/guid";

import DefaultLayout from "../../Components/Layout/DefaultLayout.vue";
import Builder from "./Components/Builder/Builder.vue";
import NavigateableQuestionTab from './Components/Builder/QuestionTab/NavigateableQuestionTab';
import OverviewTab from './Components/Builder/OverviewTab';
import QuickstartTab from "./Components/Builder/QuickstartTab";
import resource from "@core/Util/resources";
import Overview from './Components/Overview/overview.vue';

const routes = [{
    path: '/AudienceManager/',
    component: DefaultLayout,
    meta: {
        title: resource('AudienceManager_Index_Title'),
        breadcrumb: resource('Breadcrumb_AudienceManager')
    },
    children: [{
        name: RouteNames.INDEX,
        path: '',
        alias: ['Index','Overview'],
        component: Overview
    },
    {
        name: RouteNames.BUILDER,
        path: 'Builder/:audienceId',
        component: Builder,
        props: true,
        meta: {
            //Breadcrumbs should be added to our child route for now
            //we don't want our builder breadcrumb to be clickable when our URL
            //represents one of our child routes
            title: resource('AudienceManager_Builder_Title')
        },
        children: [{
            name: RouteNames.BUILDER_QUICKSTART_TAB,
            path: 'Tab/Quickstart',
            component: QuickstartTab,
            meta: {
                tabId: BuilderTabIds.QUICKSTART,
                breadcrumb: resource('Breadcrumb_AudienceManager_Builder')
            }
        }, {
            name: RouteNames.BUILDER_OVERVIEW_TAB,
            path: 'Tab/Overview',
            component: OverviewTab,
            meta: {
                tabId: BuilderTabIds.OVERVIEW,
                breadcrumb: resource('Breadcrumb_AudienceManager_Builder')
            }
        }, {
            name: RouteNames.BUILDER_QUESTION_TAB,
            path: 'Tab/:tabId?',
            alias: '',
            component: NavigateableQuestionTab,
            meta: {
                breadcrumb: resource('Breadcrumb_AudienceManager_Builder')
            }
        }]
    }, {
        name: RouteNames.NEW_AUDIENCE,
        path: 'NewAudience',
            
        //We need to redirect to a specific tab instead of the builder itself
        //navigating to the builder parent route by name ignores child routes
        redirect: to => ({ 
            name: RouteNames.BUILDER_QUICKSTART_TAB, 
            params: { audienceId: guid() },
            query: { new: true }
        })
    }
    //     {
    //     name: 'audience-manager-index',
    //     path: '',
    //     component: SingleSelect
    // }, 
    //     {
    //     name: 'view-statistics',
    //     path: 'JourneyReport/:id?',
    //     component: JourneyStatistics,
    //     meta: {
    //         title: resource('JourneyBuilder_JourneyStatistics_Title'),
    //         header: resource('JourneyBuilder_JourneyStatistics_Title'),
    //         breadcrumb: resource('Breadcrumb_JourneyBuilder_JourneyStatistics')
    //     }
    // }
    ]
}];

export {
    routes
};